import {
  GET_GOLF_INVENTORY_TYPE,
  GET_GOLF_INVENTORY_TYPE_SUCCESS,
  GET_GOLF_INVENTORY_TYPE_ERROR,
  GET_GOLF_INVENTORY_TYPE_EMPTY,
} from '../../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetGolfInventoryType = (state = initialState, action) => {
  switch (action.type) {
    case GET_GOLF_INVENTORY_TYPE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_GOLF_INVENTORY_TYPE_SUCCESS:
      console.log('hello action', action.payload);
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_GOLF_INVENTORY_TYPE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_GOLF_INVENTORY_TYPE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetGolfInventoryType;
